var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.75,
    fill: "white",
    stroke: "#7986CB",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64575 17.4999L18.1041 4.20825L26.5624 17.4999L18.1041 22.3333L9.64575 17.4999Z",
    fill: "#9FA8DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1042 4.20825L26.5626 17.4999L18.1042 22.3333V4.20825Z",
    fill: "#7986CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64575 19.3125L18.1041 24.1458L26.5624 19.3125L18.1041 30.7917L9.64575 19.3125Z",
    fill: "#9FA8DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1041 24.1458L26.5624 19.3125L18.1041 30.7917V24.1458ZM9.64575 17.5L18.1041 13.875L26.5624 17.5L18.1041 22.3333L9.64575 17.5Z",
    fill: "#7986CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1042 13.875L26.5626 17.5L18.1042 22.3333V13.875Z",
    fill: "#5C6BC0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.7b5eceea0665d1785abcffcf4c128f55.svg";
export { ForwardRef as ReactComponent };